import { getBufferGeometry, rotatePoint3D, rotatePoint3DArr } from "./geometry";
import { smoothGeometry, toLegacyGeometry } from "./legacy";
import * as THREE from "three";
// import * as BufferGeometryUtils from "three/addons/utils/BufferGeometryUtils.js";
import {
  SUBTRACTION,
  ADDITION,
  REVERSE_SUBTRACTION,
  INTERSECTION,
  DIFFERENCE,
  HOLLOW_SUBTRACTION,
  HOLLOW_INTERSECTION,
  Brush,
  Evaluator,
} from "three-bvh-csg";
import { drawBox, drawPoint } from "../draw/draw";
import {
  ldLoadCallback,
  setLaplacianMesh,
  getFacesObj,
  initModuleFunc,
  prepareDeformFunc,
  doDeformFunc,
  freeModuleFunc,
} from "./laplacianHelper";
import { load } from "laplacian-deformation";

let csgEvaluator = null;
let selectedToothMesh = null;
let selectedGingivaMesh = null;
let laplacianLoaded = false;

function loadGingivaCrossData(
  gviewer,
  gingivae,
  allTeeth,
  isIntraoral,
  callBack
) {
  // console.log("loadGingivaCrossData");
  let gingivaeLength = gingivae.length;
  let teethLength = allTeeth.length;
  if (gingivaeLength && teethLength) {
    if (!laplacianLoaded) {
      load((initModule, prepareDeform, doDeform, freeModule) => {
        ldLoadCallback(initModule, prepareDeform, doDeform, freeModule);
        laplacianLoaded = true;
        setGingivaeLaplacianMeshes(gviewer, gingivae);
        setTeethLpMeshes(gviewer, gingivae, allTeeth, isIntraoral);
        gviewer.isLaplacianLoaded = true;
        if (callBack) callBack();
      });
    } else {
      setGingivaeLaplacianMeshes(gviewer, gingivae);
      setTeethLpMeshes(gviewer, gingivae, allTeeth, isIntraoral);
      gviewer.isLaplacianLoaded = true;
      if (callBack) callBack();
    }
  } else {
    gviewer.isLaplacianLoaded = laplacianLoaded = true;
    if (callBack) callBack();
  }
}

function setGingivaeLaplacianMeshes(gviewer, gingivae) {
  gingivae.forEach((model) => {
    let mesh = gviewer.get_model_mesh(model.id);
    let oldGeometry = mesh.geometry;
    mesh.geometry = smoothGeometry(oldGeometry, true);
    mesh.originalGeometry = mesh.geometry.clone();
    oldGeometry.dispose();

    mesh.laplacianMesh = getFacesObj(mesh.geometry);
    // console.log(
    //   "setGingivaeLaplacianMeshes",
    //   model.filename,
    //   mesh.laplacianMesh
    // );
  });
}

function setTeethLpMeshes(gviewer, gingivae, allTeeth, isIntraoral) {
  const startTime = window.performance.now();
  const gingivaMeshes = [];
  const gingivaVolumes = [];
  const teethMeshes = [];
  const teethVolumes = [];

  const diff_x = isIntraoral ? 0 : 0;
  const diff_y = isIntraoral ? 0 : 0;
  const diff_z = isIntraoral ? 0 : 0;

  const diff_x1 = isIntraoral ? 1 : 1;
  const diff_y1 = isIntraoral ? 1 : 0;
  const diff_z1 = isIntraoral ? 0 : 1;

  const diff_x2 = isIntraoral ? 3 : 3;
  const diff_y2 = isIntraoral ? 3 : 0;
  const diff_z2 = isIntraoral ? 0 : 3;

  allTeeth.concat(gingivae).forEach((model) => {
    let mesh = gviewer.get_model_mesh(model.id);
    let box = model.defaultBox; //mesh.geometry.boundingBox;
    box = new THREE.Box3(
      new THREE.Vector3(box.min.x, box.min.y, box.min.z),
      new THREE.Vector3(box.max.x, box.max.y, box.max.z)
    );
    let volume = {
      box: box,
      model: model,
      // vertices: vertices,
      mesh: mesh,
    };
    if (model.isTooth) {
      teethVolumes.push(volume);
      teethMeshes.push(mesh);
      mesh.gingivaPoints = [];
    } else {
      gingivaVolumes.push(volume);
      gingivaMeshes.push(mesh);
    }
  });
  // console.log(
  //   "setTeethLpMeshes",
  //   gingivaVolumes.length,
  //   teethVolumes.length,
  //   isIntraoral
  // );

  let isFirst = false;
  teethVolumes.forEach((tvl) => {
    // isFirst = isIntraoral && tvl.model.name.includes('21');
    gingivaVolumes.forEach((gvl) => {
      if (tvl.model.isUpper != gvl.model.isUpper) {
        return;
      }
      let intersectedBox = offsetBox(gvl.box.clone().intersect(tvl.box));
      if (
        intersectedBox.size.x > 0 ||
        intersectedBox.size.y > 0 ||
        intersectedBox.size.z > 0
      ) {
        tvl.gingivaBox = tvl.model.gingivaBox = intersectedBox;
        tvl.gingivaVolume = gvl;
      }
    });

    let toothBox = tvl.model.gingivaBox;
    if (toothBox) {
      tvl.innerBox = new THREE.Box3(
        new THREE.Vector3(
          toothBox.min.x - diff_x,
          toothBox.min.y - diff_y,
          toothBox.min.z - diff_z
        ),
        new THREE.Vector3(
          toothBox.max.x + diff_x,
          toothBox.max.y + diff_y,
          toothBox.max.z + diff_z
        )
      );
      if (isFirst) drawBox(tvl.innerBox, 0xff0000, gviewer);

      tvl.outerBox = new THREE.Box3(
        new THREE.Vector3(
          toothBox.min.x - diff_x1,
          toothBox.min.y - diff_y1,
          toothBox.min.z - diff_z1
        ),
        new THREE.Vector3(
          toothBox.max.x + diff_x1,
          toothBox.max.y + diff_y1,
          toothBox.max.z + diff_z1
        )
      );
      if (isFirst) drawBox(tvl.outerBox, 0x00ff00, gviewer);

      tvl.outerBox2 = new THREE.Box3(
        new THREE.Vector3(
          toothBox.min.x - diff_x2,
          toothBox.min.y - diff_y2,
          toothBox.min.z - diff_z2
        ),
        new THREE.Vector3(
          toothBox.max.x + diff_x2,
          toothBox.max.y + diff_y2,
          toothBox.max.z + diff_z2
        )
      );
      if (isFirst) drawBox(tvl.outerBox2, 0x0000ff, gviewer);

      tvl.laplacianMesh = tvl.mesh.laplacianMesh = {
        unconstrained: [],
        staticHandles: [],
        movedHandles: [],
      };
    }

    isFirst = false;
  });

  gingivaVolumes.forEach((gvl) => {
    // const gbox = offsetBox(gvl.box);
    const gmesh = gvl.mesh;
    const position = gmesh.geometry.getAttribute("position");
    const positionArr = position.array;
    let gteethVolumes = teethVolumes.filter((tvl) => tvl.gingivaVolume == gvl);

    for (let i = 0, j = 0; i < positionArr.length; i += 3, j++) {
      let pos = new THREE.Vector3(
        positionArr[i] + gmesh.position.x, //+ gbox.center.x,
        positionArr[i + 1] + gmesh.position.y, // + gbox.center.y,
        positionArr[i + 2] + gmesh.position.z // + gbox.center.z
      );
      isFirst = false;
      gteethVolumes.forEach((tvl) => {
        // isFirst = isIntraoral && tvl.model.name.includes('21');
        let toothBox = tvl.model.gingivaBox;
        let laplacianMesh = tvl.mesh.laplacianMesh;
        if (tvl.outerBox2.containsPoint(pos)) {
          if (tvl.outerBox.containsPoint(pos)) {
            let belowСenter = isIntraoral
              ? true // pos.z < toothBox.center.z
              : pos.y < toothBox.center.y;
            if (tvl.innerBox.containsPoint(pos) && belowСenter) {
              if (isFirst) drawPoint(pos, 0xff0000, false, 0.1, gviewer);

              laplacianMesh.movedHandles.push(j);
            } else {
              laplacianMesh.unconstrained.push(j);
            }
          } else {
            laplacianMesh.staticHandles.push(j);
          }
        }
        isFirst = false;
      });
    }
  });

  teethVolumes.forEach((tvl) => {
    let laplacianMesh = tvl.mesh.laplacianMesh;
    if (laplacianMesh) {
      laplacianMesh.allHandles = laplacianMesh.movedHandles.concat(
        laplacianMesh.staticHandles
      );
      laplacianMesh.movedIndexes = laplacianMesh.movedHandles.concat(
        laplacianMesh.unconstrained
      );
      laplacianMesh.allIndexes = laplacianMesh.allHandles.concat(
        laplacianMesh.unconstrained
      );
    }
  });

  let deltaTime = window.performance.now() - startTime;
  console.log(
    `setTeethLpMeshes time ${deltaTime.toFixed(3)}ms\n`,
    teethVolumes
  );
}

function prepareLaplacianDeform(gviewer, tooth, toothMesh, gingivae) {
  if (tooth && toothMesh && selectedToothMesh != toothMesh) {
    selectedToothMesh = toothMesh;

    let gingiva = gingivae.find((g) => g.isUpper == tooth.isUpper);
    if (gingiva) {
      let gingivaMesh = gviewer.get_model_mesh(gingiva.id);
      if (selectedGingivaMesh != gingivaMesh) {
        selectedGingivaMesh = gingivaMesh;
        initModuleFunc(gingivaMesh.laplacianMesh);
      }

      let toohLpMesh = toothMesh.laplacianMesh;
      prepareDeformFunc(toohLpMesh.allHandles, toohLpMesh.unconstrained);
    }
  }
}

function applyMultiselectRotateToGingiva(gviewer, teeth, gingivae) {
  if (gviewer && teeth && gingivae) {
    for (const tooth of teeth) {
      let toothMesh = gviewer.get_model_mesh(tooth.id);
      let gingiva = gingivae.find((g) => g.isUpper == tooth.isUpper);
      if (toothMesh && gingiva) {
        selectedToothMesh = toothMesh;
        let gingivaMesh = gviewer.get_model_mesh(gingiva.id);
        if (selectedGingivaMesh != gingivaMesh) {
          selectedGingivaMesh = gingivaMesh;
          initModuleFunc(gingivaMesh.laplacianMesh);
        }
        let toohLpMesh = toothMesh.laplacianMesh;
        prepareDeformFunc(toohLpMesh.allHandles, toohLpMesh.unconstrained);
        applyRotateToGingiva();
      }
    }
  }
}

function applyMoveToGingiva(offset) {
  if (selectedToothMesh && selectedGingivaMesh) {
    let toothLpMesh = selectedToothMesh.laplacianMesh;
    let gingivaLpMesh = selectedGingivaMesh.laplacianMesh;
    var handlesPositionsArr = [];
    for (const mvHandle of toothLpMesh.movedHandles) {
      handlesPositionsArr.push([
        gingivaLpMesh.positions[mvHandle][0] + offset[0],
        gingivaLpMesh.positions[mvHandle][1] + offset[1],
        gingivaLpMesh.positions[mvHandle][2] + offset[2],
      ]);
    }
    for (const stHandle of toothLpMesh.staticHandles) {
      handlesPositionsArr.push([
        gingivaLpMesh.positions[stHandle][0],
        gingivaLpMesh.positions[stHandle][1],
        gingivaLpMesh.positions[stHandle][2],
      ]);
    }

    var result = doDeformFunc(handlesPositionsArr);
    applyLaplacianResult(result);
  }
}

function applyRotateToGingiva() {
  //angleX, angleY, angleZ) {
  if (selectedToothMesh && selectedGingivaMesh) {
    let gingivaLpMesh = selectedGingivaMesh.laplacianMesh;
    let toothLpMesh = selectedToothMesh.laplacianMesh;
    let handlesPositionsArr = [];

    let gingivaPosition = selectedGingivaMesh.position;
    if (!selectedToothMesh.defaultPosition)
      selectedToothMesh.defaultPosition = new THREE.Vector3(); // selectedToothMesh.position.clone();
    let toothPosition = selectedToothMesh.defaultPosition;

    let subVector = new THREE.Vector3().subVectors(
      gingivaPosition,
      toothPosition
    );

    let toothMatrix = selectedToothMesh.matrixWorld.clone(); // ?makeTranslation
    // console.log(
    //   "applyRotateToGingiva toothPosition toothMatrix",
    //   toothPosition,
    //   cloneMatrix
    // );

    for (const mvHandle of toothLpMesh.movedHandles) {
      // let pointArr = gingivaLpMesh.savedPositions[mvHandle];
      // let point = new THREE.Vector3(pointArr[0], pointArr[1], pointArr[2]);
      // let globalPoint1 = point.clone().add(gingivaPosition);
      // let toothPoint = globalPoint1.clone().sub(toothPosition);

      let point = gingivaLpMesh.savedVectors[mvHandle];
      let newPoint = point.clone().add(subVector);
      newPoint.applyMatrix4(toothMatrix);
      newPoint.sub(gingivaPosition);
      handlesPositionsArr.push([newPoint.x, newPoint.y, newPoint.z]);
    }
    for (const stHandle of toothLpMesh.staticHandles) {
      handlesPositionsArr.push([
        gingivaLpMesh.positions[stHandle][0],
        gingivaLpMesh.positions[stHandle][1],
        gingivaLpMesh.positions[stHandle][2],
      ]);
    }

    var result = doDeformFunc(handlesPositionsArr);
    applyLaplacianResult(result);
  }
}

function applyLaplacianResult(result) {
  if (selectedToothMesh && selectedGingivaMesh) {
    let gingivaLpMesh = selectedGingivaMesh.laplacianMesh;
    let toothLpMesh = selectedToothMesh.laplacianMesh;

    // for (var i = 0; i < gingivaLpMesh.positions.length; i++) {
    //   gingivaLpMesh.positions[i] = result[i];
    // }

    for (const i of toothLpMesh.movedIndexes) {
      let resultPos = result[i];
      if (
        !result ||
        !result.length ||
        result.length < 3 ||
        isNaN(resultPos[0]) ||
        isNaN(resultPos[1]) ||
        isNaN(resultPos[2])
      ) {
        continue;
      }
      gingivaLpMesh.positions[i] = resultPos; // [NaN, NaN, NaN]
    }

    const newGeometry = new THREE.BufferGeometry();
    const vertArr = [];
    gingivaLpMesh.positions.forEach((pos) => {
      vertArr.push(...pos);
    });
    const vertices = new Float32Array(vertArr);
    newGeometry.setAttribute(
      "position",
      new THREE.BufferAttribute(vertices, 3)
    );

    const indices = [];
    gingivaLpMesh.cells.forEach((cell) => {
      indices.push(...cell);
    });
    newGeometry.setIndex(indices);

    let oldGeometry = selectedGingivaMesh.geometry;
    // let colorAttr = oldGeometry.getAttribute("color");
    // if (colorAttr) {
    //   newGeometry.setAttribute("color", colorAttr.clone());
    // }
    oldGeometry.dispose();
    selectedGingivaMesh.geometry = toLegacyGeometry(newGeometry);
    // selectedGingivaMesh.geometry = smoothGeometry(newGeometry);
  }
}

function getCrossedGingiva(gviewer, tooth, toothMesh, gingivae) {
  if (tooth && tooth.gingivaBox) {
    if (!toothMesh.crossedGingiva) {
      let startTime = window.performance.now();

      let gingiva = gingivae.find((g) => g.isUpper == tooth.isUpper);
      let gingivaMesh = gviewer.get_model_mesh(gingiva.id);

      const bgeometry = getBufferGeometry(gingivaMesh.geometry);
      // gingivaMesh.geometry.clone();
      bgeometry.computeBoundingBox();
      bgeometry.computeBoundingSphere();
      const brush1 = new Brush(bgeometry);
      brush1.position.x = gingivaMesh.position.x;
      brush1.position.y = gingivaMesh.position.y;
      brush1.position.z = gingivaMesh.position.z;
      brush1.updateMatrixWorld();
      let gbox = offsetBox(
        bgeometry.boundingBox,
        brush1.position.x,
        brush1.position.y,
        brush1.position.z
      );

      const box = tooth.gingivaBox;
      let diff = 6;
      const boxGeometry = new THREE.BoxGeometry(
        box.size.x + diff,
        box.size.y + diff,
        box.size.z + diff
      );
      // drawBox(gbox, 0x0000ff);
      // drawBox(box, 0xff0000);

      const brush2 = new Brush(boxGeometry);
      brush2.position.x = box.center.x;
      brush2.position.y = box.center.y;
      brush2.position.z = box.center.z;
      brush2.updateMatrixWorld();

      if (!csgEvaluator) {
        csgEvaluator = new Evaluator();
        csgEvaluator.attributes = ["position", "normal"];
        csgEvaluator.useGroups = false;
      }

      const crossedMesh = csgEvaluator.evaluate(
        brush1,
        brush2,
        HOLLOW_INTERSECTION
      );
      let crossedGeometry = crossedMesh.geometry;
      let smoothedGeometry = smoothGeometry(crossedGeometry);
      crossedMesh.geometry = smoothedGeometry;
      // createMorphAttributes(result.geometry);
      let material = new THREE.MeshPhongMaterial({
        // color: 0x0000ff,
        flatShading: true,
        // wireframe: true,
        vertexColors: true,
      });
      // let material = new THREE.MeshPhongMaterial({
      //   color: new THREE.Color(vueApp.gingivaeColor),
      //   flatShading: false,
      //   specular: 0x050505,
      //   shininess: 100,
      //   side: 2,
      //   vertexColors: true,
      // });
      material = gingivaMesh.material.clone();
      // material.vertexColors = true;
      // material.flatShading = true;

      crossedMesh.material = material;
      let deltaTime = window.performance.now() - startTime;
      console.log(`getCrossedGingiva time ${deltaTime.toFixed(3)}ms\n`);
      toothMesh.crossedGingiva = crossedMesh;
    }
    setLaplacianMesh(toothMesh.crossedGingiva, tooth.gingivaBox, 1);
  }
  return toothMesh.crossedGingiva;
}

function createMorphAttributes(geometry) {
  // const geometry = new THREE.BoxGeometry(2, 2, 2, 32, 32, 32);

  // create an empty array to  hold targets for the attribute we want to morph
  // morphing positions and normals is supported
  geometry.morphAttributes.position = [];

  // the original positions of the cube's vertices
  const positionAttribute = geometry.attributes.position;

  const widthPositions = [];
  const heightPositions = [];
  const depthPositions = [];

  // for the next morph target we'll move the cube's vertices onto the surface of a sphere
  const spherePositions = [];

  // for the next morph target, we'll twist the cubes vertices
  const twistPositions = [];
  const direction = new THREE.Vector3(1, 0, 0);
  const vertex = new THREE.Vector3();

  let length = positionAttribute.count; // / 2;

  geometry.computeBoundingBox();
  let boundingBox = geometry.boundingBox;
  console.log("boundingBox", boundingBox);

  for (let i = 0; i < length; i++) {
    let x = positionAttribute.getX(i);
    let y = positionAttribute.getY(i);
    let z = positionAttribute.getZ(i);

    let w = x + (boundingBox.max.y - y);
    // let w = x + (boundingBox.max.z - z);
    widthPositions.push(w, y, z);

    let h = y * 2 - boundingBox.max.y;
    // let h = y + (boundingBox.max.z - z);
    heightPositions.push(x, h, z);

    let d = z + (boundingBox.max.y - y);
    // let d = z * 2 - boundingBox.max.z;
    depthPositions.push(x, y, d);

    spherePositions.push(
      x * Math.sqrt(1 - (y * y) / 2 - (z * z) / 2 + (y * y * z * z) / 3),
      y * Math.sqrt(1 - (z * z) / 2 - (x * x) / 2 + (z * z * x * x) / 3),
      z * Math.sqrt(1 - (x * x) / 2 - (y * y) / 2 + (x * x * y * y) / 3)
    );

    // stretch along the x-axis so we can see the twist better
    vertex.set(x * 2, y, z);

    vertex
      .applyAxisAngle(direction, (Math.PI * x) / 2)
      .toArray(twistPositions, twistPositions.length);
  }

  geometry.morphAttributes.position[0] = new THREE.Float32BufferAttribute(
    widthPositions,
    3
  );
  geometry.morphAttributes.position[1] = new THREE.Float32BufferAttribute(
    heightPositions,
    3
  );
  geometry.morphAttributes.position[2] = new THREE.Float32BufferAttribute(
    depthPositions,
    3
  );

  geometry.morphAttributes.position[3] = new THREE.Float32BufferAttribute(
    spherePositions,
    3
  );
  geometry.morphAttributes.position[4] = new THREE.Float32BufferAttribute(
    twistPositions,
    3
  );

  return geometry;
}

export {
  loadGingivaCrossData,
  prepareLaplacianDeform,
  applyMultiselectRotateToGingiva,
  applyMoveToGingiva,
  applyRotateToGingiva,
};
